import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
  LoadingOutlined
} from '@ant-design/icons';
import {Typography} from 'antd';
import {BusinessStatus} from 'api/generated';
import React from 'react';

type Props = {
  status: BusinessStatus | undefined | null;
};

const {Text} = Typography;

export const CompanyStatus: React.FC<Props> = ({status}) => {
  switch (status) {
    case BusinessStatus.RENAMED:
      return (
        <Text type="danger" strong>
          <CloseCircleOutlined /> Renamed
        </Text>
      );
    case BusinessStatus.DISSOLVED:
      return (
        <Text type="danger" strong>
          <CloseCircleOutlined /> Dissolved
        </Text>
      );
    case BusinessStatus.TRANSFORMED:
      return (
        <Text type="danger" strong>
          <CloseCircleOutlined /> Transformed
        </Text>
      );
    case BusinessStatus.INACTIVE:
      return (
        <Text type="danger" strong>
          <CloseCircleOutlined /> Inactive
        </Text>
      );
    case BusinessStatus.NOT_FOUND:
      return (
        <Text type="danger" strong>
          <CloseCircleOutlined /> Not found
        </Text>
      );
    case BusinessStatus.ACTIVE:
      return (
        <Text type="success" strong>
          <CheckCircleOutlined /> Active
        </Text>
      );
    case BusinessStatus.UNDER_REVIEW:
      return (
        <Text type="warning" strong>
          <InfoCircleOutlined /> Under review
        </Text>
      );
    case BusinessStatus.PROCESSING:
      return (
        <Text type="secondary" strong>
          <LoadingOutlined /> Processing
        </Text>
      );
  }
  return (
    <Text type="danger" strong>
      <CloseCircleOutlined /> Not verified
    </Text>
  );
};
